import { render, staticRenderFns } from "./ConfirmProblems.vue?vue&type=template&id=09a0f194&scoped=true"
import script from "./ConfirmProblems.vue?vue&type=script&lang=js"
export * from "./ConfirmProblems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0f194",
  null
  
)

export default component.exports